import { useAppSelector } from '@/store/hooks';
import { selectLoadingStylepacks, selectStylepacks } from '@/store/slices/stylepacks/selectors';
import Container from '@ui/container/container';
import { useMemo } from 'react';
import { selectWorkingProject } from '@/store/slices/project/selectors';
import EmptyStylepackView from './empty/empty-stylepack-view';
import LoadingSpinner from '@ui/loading-spinner/loading-spinner';
import StylepackProvider from './stylepack-context-provider';
import StylepackHeader from './stylepack-header';
import StylepackContent from './stylepack-content';

export default function Stylepacks() {
  const stylepacks = useAppSelector(selectStylepacks);
  const workingProject = useAppSelector(selectWorkingProject);
  const loadingStylepacks = useAppSelector(selectLoadingStylepacks);

  const selectedStylepack = useMemo(() => {
    const session = workingProject?.sessions[0];
    if (session?.streaming_options?.stylepackId && stylepacks) {
      return stylepacks.find((stylepack) => stylepack.stylePack === session?.streaming_options?.stylepackId);
    }
  }, [workingProject, stylepacks]);

  if (loadingStylepacks) {
    return <LoadingSpinner />; // prob could do more here, no figmas yet
  }

  if (!selectedStylepack) {
    return <EmptyStylepackView />;
  }

  return (
    <StylepackProvider selectedStylepack={selectedStylepack}>
      <Container className="flex ai-center jc-center flex-column gap-40 position-relative" width="100%">
        <StylepackHeader />
        <StylepackContent />
      </Container>
    </StylepackProvider>
  );
}
